import React from "react";

function CalendarIcon({opacity}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="20"
      fill="none"
      viewBox="0 0 18 20"
    >
      <path
        fill="#313131"
        fillOpacity={opacity ? opacity : 0.56}
        fillRule="evenodd"
        d="M5 2h8V0h2v2h1a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h1V0h2v2zM2 6v12h14V6H2zm2 3h2v2H4V9zm4 0h2v2H8V9zm4 0h2v2h-2V9zm0 4h2v2h-2v-2zm-4 0h2v2H8v-2zm-4 0h2v2H4v-2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default CalendarIcon;
